<template>
    <span :class="wrapperClass" :style="bgColor">
        <slot name="prependIcon"></slot>
        <slot></slot>
        <slot name="appendIcon"></slot>
    </span>
</template>

<script>
import { twJoin } from 'tailwind-merge';

export default {
    name: 'GdTag',
    props: {
        variant: {
            type: String,
            default: 'primary'
        },
        size: {
            type: String,
            default: 'md'
        },
        pill: {
            type: Boolean,
            default: false
        },
        outline: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        wrapperClass() {
            const baseClass = 'inline-flex items-center gap-1 w-auto font-semibold';
            const variantClass = {
                primary: 'text-primary border-primary',
                success: 'text-success border-success',
                warning: 'text-warning border-warning',
                danger: 'text-danger border-danger'
            };
            const sizeClass = {
                sm: 'p-1 text-sm',
                md: 'px-2 py-1 text-base',
                lg: 'px-4 py-2 text-lg'
            };
            const pillClass = this.pill ? 'rounded-full' : 'rounded-md';
            const borderClass = this.outline ? 'border' : '';
            return twJoin(baseClass, sizeClass[this.size], borderClass, pillClass, variantClass[this.variant]);
        },
        bgColor() {
            switch (this.variant) {
                case 'primary':
                    return `background-color: color-mix(in srgb, var(--brand-primary), white)`;
                case 'success':
                    return `background-color: color-mix(in srgb, var(--brand-success), white)`;
                case 'warning':
                    return `background-color: color-mix(in srgb, var(--brand-warning), white)`;
                case 'danger':
                    return `background-color: color-mix(in srgb, var(--brand-danger), white)`;
            }
        }
    }
}
</script>